import { FormElement } from "./FormElement";
import { DOMTemplate } from "../../denki";
import { node } from "../Util";
import { FieldInputElement } from "./FieldInputElement";

export class FormFileElement extends FormElement<string> implements FieldInputElement {
  public readonly fieldsElement: HTMLElement;
  public readonly fileElement: HTMLInputElement;
  public readonly clearButton: HTMLButtonElement;

  constructor(name: string, template: DOMTemplate) {
    super(name, template.get("field-element"));
    this.fieldsElement = this.element.querySelector("[data-role=elements]");
    const id = name;
    this.virtualInput.setAttribute("data-id", id);
    this.virtualInput.setAttribute("name", id);
    this.virtualInput.addEventListener("change", () => {
    });
    const attributes = {
      type: 'file',
      name,
    };
    let fileElement = node('input', attributes) as HTMLInputElement;
    fileElement.addEventListener("change", () => {
      this.value = fileElement.value;
      clearButton.disabled = fileElement.value === "";
    });
    this.fileElement = fileElement;

    const fieldset = node('div', { class: 'input-file' });
    fieldset.appendChild(fileElement);
    const clearButton = node('button', { class: 'clearButton' }, '削除');
    clearButton.disabled = true;
    clearButton.addEventListener('click', () => {
      fileElement.value = "";
      fileElement.dispatchEvent(new CustomEvent("change"));
    });
    fieldset.appendChild(clearButton);
    this.fieldsElement.appendChild(fieldset);
  }

  public get accept(): string[] {
    return this.fileElement.getAttribute("accept").split(",");
  }

  public set accept(types: string[]) {
    this.fileElement.setAttribute("accept", types.join(","));
  }

  protected onUpdateValue(value: string) {
  }

  public focus() {
    this.fileElement.focus();
  }

  get validationErrors(): Promise<string[]> {
    return Promise.resolve([]);
  }
}